import { render, staticRenderFns } from "./SelfEmployed.vue?vue&type=template&id=5d60f62c&scoped=true"
import script from "./SelfEmployed.vue?vue&type=script&lang=js"
export * from "./SelfEmployed.vue?vue&type=script&lang=js"
import style0 from "./SelfEmployed.vue?vue&type=style&index=0&id=5d60f62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60f62c",
  null
  
)

export default component.exports